import { ADD_ATTACHMENTS, REMOVE_ATTACHMENTS, REMOVE_FILE } from './constants';

export function addAttachments(attachments) {
  return {
    type: ADD_ATTACHMENTS,
    payload: attachments,
  };
}

export function removeAttachments() {
  return {
    type: REMOVE_ATTACHMENTS,
    payload: [],
  };
}

export function removeFile(fileName) {
  return {
    type: REMOVE_FILE,
    payload: fileName,
  };
}



// WEBPACK FOOTER //
// ./src/Modules/UploadCashBackFile/UploadComponent/actions.js